import { render } from "./AccountPopup.vue?vue&type=template&id=77973c0a"
import script from "./AccountPopup.vue?vue&type=script&lang=js"
export * from "./AccountPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__